export default "__VITE_ASSET__DtPcfGfg__"